module.exports = __webpack_public_path__ + "img/icon-sv4.6d1aeb3b.png";